<template>
  <div class="row">
    <div class="col-12">
      <h4 class="text-green text-center">{{ pageControl.pageName }}</h4>
      <coverage-page-condition
        ref="condition"
        :pageControl="pageControl"
        :form="form"
        :validate="validate"
      />
      <ul class="nav" role="tablist" v-if="showMaxSingle || showMaxMulti || showMaxCustom">
        <li
          class="nav-item nav-first"
          :class="{ 'nav-active': pageControl.settingType == 1 }"
          @click="switchSettingType"
        >
          <a class="nav-link" role="tab" data-toggle="tab"> 保障公式設定 </a>
        </li>
        <li
          class="nav-item nav-second"
          :class="{ 'nav-active': pageControl.settingType == 2 }"
          @click="switchSettingType"
        >
          <a class="nav-link" role="tab" data-toggle="tab"> 取大設定 </a>
        </li>
      </ul>
      <form class="form" v-if="pageControl.settingType == 1">
        <div class="panel panel-form searchArea">
          <!-- 保障期間 -->
          <coverage-page-period
            v-if="showPeriod"
            :pageControl="pageControl"
            :form="form"
            :validate="validate"
          />
          <!-- 保障公式 -->
          <coverage-page-formula
            v-if="showFormula"
            :pageControl="pageControl"
            :form="form"
            :validate="validate"
          />
          <!-- 保障期間(多選) -->
          <coverage-page-period-multi
            v-if="showPeriodMulti"
            :pageControl="pageControl"
            :form="form"
            :validate="validate"
          />
          <!-- 保障公式(多選) -->
          <coverage-page-formula-multi
            v-if="showFormulaMulti"
            :pageControl="pageControl"
            :form="form"
            :validate="validate"
          />
          <!-- 保障期間(祝壽金) -->
          <coverage-page-period-goodwish
            v-if="showPeriodGoodwish"
            :pageControl="pageControl"
            :form="form"
            :validate="validate"
          />
          <!-- 保障公式(祝壽金) -->
          <coverage-page-formula-goodwish
            v-if="showFormulaGoodwish"
            :pageControl="pageControl"
            :form="form"
            :validate="validate"
          />
          <!-- 保障期間(其他) -->
          <coverage-page-period-single
            v-if="showPeriodSingle"
            :pageControl="pageControl"
            :form="form"
            :validate="validate"
          />
          <!-- 保障公式(其他) -->
          <coverage-page-formula-single
            v-if="showFormulaSingle"
            :pageControl="pageControl"
            :form="form"
            :validate="validate"
          />

          <!-- 保證給付年齡 -->
          <div
            class="form-group row"
            v-if="showPeriodMulti && showFormulaMulti"
          >
            <label class="col-2 text-right">保證給付年齡</label>
            <div class="col-10 d-inline-grid">
              <div class="checkbox radio-inline mb-15">
                <input
                  type="number"
                  class="form-control form-control-inline show-input w-100"
                  :min="0"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                  maxlength="3"
                  v-model="form.guaranteepayage"
                />
                <span class="lh-40">歲</span>
              </div>
              <div
                class="checkbox radio-inline mb-15"
                v-if="this.pageControl.showNextDay"
              >
                <input
                  type="checkbox"
                  id="isNextDay"
                  v-model="form.isNextDay"
                />
                <label class="hide-label" for="isNextDay"></label>
                <span class="lh-40 ml-50">翌日領取</span>
              </div>
            </div>
          </div>

          <!-- 保障上限至 -->
          <div class="form-group row">
            <label class="col-2 text-right">保障上限至</label>
            <div class="col-10 d-inline-grid">
              <div class="checkbox radio-inline mb-15">
                <input
                  type="number"
                  class="form-control form-control-inline show-input w-100"
                  :min="0"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                  maxlength="3"
                  v-model="form.age_limt"
                />
                <span class="lh-40">歲</span>
              </div>
            </div>
          </div>

          <div class="text-center">
            <button
              type="button"
              class="btn btn-primary"
              @click="clickSave(getReqForSave(form))"
              v-show="!form.isEditMode"
            >
              新增
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="clickSave(getReqForSave(form))"
              v-show="form.isEditMode"
            >
              更新
            </button>
            <button
              type="button"
              class="btn btn-default"
              @click="clickCancel()"
            >
              取消
            </button>
          </div>
        </div>
      </form>
      <form class="form" v-else>
        <div class="panel panel-form searchArea">
          <add-get-max-formula-component
            :pageControl="pageControl"
            :form="form"
            :validate="validate"
            v-if="showMaxSingle"
          >
          </add-get-max-formula-component>
          <add-get-max-formula-component-2
            :pageControl="pageControl"
            :form="form"
            :validate="validate"
            v-if="showMaxMulti"
          >
          </add-get-max-formula-component-2>
          <add-get-max-formula-component-3
            :pageControl="pageControl"
            :form="form"
            :validate="validate"
            :details="maxItemDetails"
            v-if="showMaxCustom"
            ref="getMaxCustom"
          >
          </add-get-max-formula-component-3>
          <div class="text-center">
            <button
              type="button"
              class="btn btn-primary"
              v-if="showMaxSingle"
              @click="clickSaveMax(getReqForMaxSave(form))"
            >
              {{ hasGetMax ? "更新" : "新增" }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              v-if="showMaxMulti"
              @click="clickSaveMax(getReqForMaxSave(form))"
            >
              {{ form.isEditMode && form.getMaxId ? "更新" : "新增" }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              v-if="showMaxCustom"
              @click="clickSaveMaxCustom()"
            >
              {{ form.isEditMode ? "更新" : "新增" }}
            </button>
            <button
              type="button"
              class="btn btn-default"
              v-if="showMaxMulti || showMaxCustom"
              @click="clickCancelMax()"
            >
              取消
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="col-12 mt-40">
      <button type="button" class="btn btn-default" @click="clickAllDelete()">
        全部刪除
      </button>
      <button type="button" class="btn btn-default" @click="clickMultDelete()">
        刪除多筆
      </button>
      <button
        type="button"
        class="btn btn-default"
        @click="clickAllDeleteMax()"
        v-if="hasGetMax"
      >
        全部刪除取大公式(包含FORM資料)
      </button>
      <button type="button" class="btn btn-default" @click="clickCopy()">
        複製
      </button>
    </div>
    <div class="col-12">
      <table class="table datatable">
        <thead>
          <tr>
            <th width="10" class="text-center">選取</th>
            <th width="100" class="text-center">排序</th>
            <th width="110" class="text-center">編輯/刪除</th>
            <th width="500" class="text-center">保障公式輸入結果</th>
          </tr>
        </thead>
        <tbody v-if="filterFormularData.length">
          <tr
            v-for="(item, i) in filterFormularData"
            :key="`formular-data-${i}`"
            :class="{
              active: form.conditionId === item.conditionid,
              active: form.getMaxId && form.getMaxId === item.getmaxid,
            }"
          >
            <td class="td-center">
              <div class="checkbox radio-inline mr-0 w-20">
                <input
                  type="checkbox"
                  :id="`formular-${i}`"
                  :value="item"
                  v-model="formularDataSelected"
                  :disabled="!item.conditionid"
                />
                <label :for="`formular-${i}`"></label>
              </div>
            </td>
            <td class="text-center">
              <button
                type="button"
                class="btn btn-default fa fa-arrow-up"
                @click="clickChangePriority(item, filterFormularData[i - 1])"
                :disabled="i == 0 || form.isEditMode || !item.conditionid"
              ></button>
              <button
                type="button"
                class="btn btn-default fa fa-arrow-down"
                @click="clickChangePriority(item, filterFormularData[i + 1])"
                :disabled="
                  i == filterFormularData.length - 1 ||
                  form.isEditMode ||
                  !item.conditionid
                "
              ></button>
            </td>
            <td class="text-center">
              <button
                type="button"
                class="btn btn-primary btn-sm"
                @click="clickEdit($event, item)"
                :disabled="form.isEditMode"
                v-if="item.conditionid"
              >
                編輯
              </button>
              <button
                type="button"
                class="btn btn-default btn-sm"
                @click="clickDelete(item)"
                :disabled="form.isEditMode"
                v-if="item.conditionid"
              >
                刪除
              </button>
              <button
                type="button"
                class="btn btn-primary btn-sm"
                @click="clickEditMax($event, item)"
                :disabled="form.isEditMode"
                v-if="item.getmaxid && (showMaxMulti || showMaxCustom)"
              >
                編輯
              </button>
              <button
                type="button"
                class="btn btn-default btn-sm"
                @click="clickDeleteMax(item)"
                :disabled="form.isEditMode"
                v-if="!item.conditionid"
              >
                刪除
              </button>
            </td>
            <td style="white-space: pre-line">{{ item.detail }}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td class="text-center" colspan="6">
              <h4 class="mb-3">查無{{ pageControl.pageName }}資訊</h4>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ThisMixin from "./CoveragePage";
import CoveragePageCondition from "./CoveragePageCondition";
import CoveragePagePeriod from "./CoveragePagePeriod";
import CoveragePageFormula from "./CoveragePageFormula";
import CoveragePagePeriodMulti from "./CoveragePagePeriodMulti";
import CoveragePageFormulaMulti from "./CoveragePageFormulaMulti";
import CoveragePagePeriodGoodwish from "./CoveragePagePeriodGoodwish";
import CoveragePageFormulaGoodwish from "./CoveragePageFormulaGoodwish";
import CoveragePagePeriodSingle from "./CoveragePagePeriodSingle";
import CoveragePageFormulaSingle from "./CoveragePageFormulaSingle";
import AddGetMaxFormulaComponent from "./AddGetMaxFormulaComponent";
import AddGetMaxFormulaComponent2 from "./AddGetMaxFormulaComponent2";
import AddGetMaxFormulaComponent3 from "./AddGetMaxFormulaComponent3";
export default {
  name: "CoveragePage",
  mixins: [ThisMixin],
  props: {
    customPageControl: {
      type: Object,
      default: () => {
        return {};
      },
    },
    customDefaultForm: {
      type: Object,
      default: () => {
        return {};
      },
    },
    customNeedValidate: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {
    CoveragePageCondition,
    CoveragePagePeriod,
    CoveragePageFormula,
    CoveragePagePeriodMulti,
    CoveragePageFormulaMulti,
    CoveragePagePeriodGoodwish,
    CoveragePageFormulaGoodwish,
    CoveragePagePeriodSingle,
    CoveragePageFormulaSingle,
    AddGetMaxFormulaComponent,
    AddGetMaxFormulaComponent2,
    AddGetMaxFormulaComponent3,
  },
  computed: {
    ...mapGetters(["BaseUrl", "RouterPara"]),
    showPeriod() {
      return this.pageControl.pageBlock.includes("period");
    },
    showFormula() {
      return this.pageControl.pageBlock.includes("formula");
    },
    showPeriodMulti() {
      return this.pageControl.pageBlock.includes("periodMulti");
    },
    showFormulaMulti() {
      return this.pageControl.pageBlock.includes("formulaMulti");
    },
    showPeriodGoodwish() {
      return this.pageControl.pageBlock.includes("periodGoodwish");
    },
    showFormulaGoodwish() {
      return this.pageControl.pageBlock.includes("formulaGoodwish");
    },
    showPeriodSingle() {
      return this.pageControl.pageBlock.includes("periodSingle");
    },
    showFormulaSingle() {
      return this.pageControl.pageBlock.includes("formulaSingle");
    },
    showMaxSingle() {
      return (
        this.productData.productType == 4 &&
        this.pageControl.pageBlock.includes("maxSingle")
      );
    },
    showMaxMulti() {
      return (
        this.productData.productType == 4 &&
        this.pageControl.pageBlock.includes("maxMulti")
      );
    },
    showMaxCustom() {
      return (
        this.productData.productType != 5 &&
        this.pageControl.pageBlock.includes("maxCustom")
      );
    },
    filterFormularData() {
      if (
        this.pageControl.pageName !== "生存保險金" &&
        this.pageControl.parentCategoryName
      ) {
        // 若為其他保障 用categoryId來濾
        if (this.pageControl.pageName === "其他保障" &&  this.form.categoryId !==''){
          // console.log('this.pageControl',this.pageControl)
          // console.log('this.formularData',this.formularData)
          // console.log('this.form',this.form)
          return this.formularData.filter(
            (item) =>
              item.categoryid == this.form.categoryId
          );

        } else {
          return this.formularData.filter(
            (item) =>
              item.parentcategoryname == this.pageControl.parentCategoryName
          );
        }
      } else {
        return this.formularData;
      }
    },
    filterFormularDataSelected() {
      return this.formularDataSelected.filter(
        (item) => item.parentcategoryname == this.pageControl.parentCategoryName
      );
    },
    hasGetMax() {
      return this.formularData.filter((item) => !item.conditionid).length > 0;
    },
  },
  watch: {
    "form.annual"(value) {
      if (value.includes("年期")) {
        this.form.end = Number(value.replace("年期", ""));
        this.form.endUnit = 1;
      } else if (value.includes("歲")) {
        this.form.end = Number(value.replace("歲", ""));
        this.form.endUnit = 2;
      }
    },
  },
  methods: {
    pageInit() {
      this.custom.pageControl = this.customPageControl;
      this.custom.defaultForm = this.customDefaultForm;
      this.custom.needValidate = this.customNeedValidate;
      this.init();
    },
    getMaxCustomInit() {
      [ ...Array(5) ].forEach((e, index) => {
        let disabled = index != 0;
        let detail = JSON.parse(JSON.stringify(this.defaultMaxItemDetail));
        detail.disabled = disabled;
        this.maxItemDetails.push(detail);
      });
    },
    //=================click event=================
    async clickEdit(e, data) {
      this.form.isEditMode = true;
      this.pageControl.settingType = 1;
      await this.setFormData(data);
      //在向後端取資料時，axios會改變按鈕狀態，因此已非同步的方式完成編輯資料取值後再重新disabled
      // eslint-disable-next-line no-undef
      $(e.target)[0].disabled = true;
    },
    clickSave(req) {
      if (this.validateForm()) return;
      this.saveData(req);
    },
    clickCancel() {
      this.resetForm();
    },
    clickDelete(data) {
      if (!confirm("確認要刪除此筆資料!?")) {
        return;
      }
      const req = {
        PRODUCTID: this.form.productId,
        company:  this.productData.company.COMPSNM,
        insuranceName:  this.productData.insuranceName,
        insuranceCode:  this.productData.insuranceCode,
        userId: this.$store.state.userInfo.mainUserId ? this.$store.state.userInfo.mainUserId : this.$store.state.userInfo.id,
        userName: this.$store.state.userInfo.mainUserId ? "" : this.$store.state.userInfo.name,
        delList: [{ 
          conditionId: data.conditionid,
          detail: data.detail.replaceAll("%", "％"),
        }],
      };
      this.deleteCoverage(req);
    },
    clickMultDelete() {
      if (!this.filterFormularDataSelected.length) {
        this.$toast.info({ title: "未選擇任何資料刪除" });
        return;
      }
      if (!confirm("確認要刪除多筆資料!?")) {
        return;
      }
      const req = {
        PRODUCTID: this.form.productId,
        company:  this.productData.company.COMPSNM,
        insuranceName:  this.productData.insuranceName,
        insuranceCode:  this.productData.insuranceCode,
        userId: this.$store.state.userInfo.mainUserId ? this.$store.state.userInfo.mainUserId : this.$store.state.userInfo.id,
        userName: this.$store.state.userInfo.mainUserId ? "" : this.$store.state.userInfo.name,
        delList: [],
      };
      this.filterFormularDataSelected.forEach((item) => {
        const temp = { 
          conditionId: item.conditionid,
          detail: item.detail.replaceAll("%", "％"),
        };
        req.delList.push(temp);
      });
      this.deleteCoverage(req);
    },
    clickAllDelete() {
      if (!this.filterFormularData.length) {
        this.$toast.info({ title: "無資料可刪除" });
        return;
      }
      if (!confirm("確認要刪除所有資料!?")) {
        return;
      }
      const req = {
        PRODUCTID: this.form.productId,
        company:  this.productData.company.COMPSNM,
        insuranceName:  this.productData.insuranceName,
        insuranceCode:  this.productData.insuranceCode,
        userId: this.$store.state.userInfo.mainUserId ? this.$store.state.userInfo.mainUserId : this.$store.state.userInfo.id,
        userName: this.$store.state.userInfo.mainUserId ? "" : this.$store.state.userInfo.name,
        delList: [],
      };
      this.filterFormularData
        .filter((item) => item.conditionid)
        .forEach((item) => {
          const temp = { 
            conditionId: item.conditionid,
            detail: item.detail.replaceAll("%", "％"),
          };
          req.delList.push(temp);
        });
      this.deleteCoverage(req);
    },
    clickCopy() {
      if (!this.filterFormularDataSelected.length) {
        this.$toast.info({ title: "未選擇任何資料複製" });
        return;
      }
      const req = {
        copyList: [],
      };
      this.filterFormularDataSelected.forEach((item) => {
        const temp = { conditionId: item.conditionid };
        req.copyList.push(temp);
      });
      this.copyCoverage(req);
    },
    clickChangePriority(item1, item2) {
      const req = {
        conditionId1: item1.conditionid,
        priority1: item1.priority,
        conditionId2: item2.conditionid,
        priority2: item2.priority,
      };
      this.exchangeConditionPriority(req);
    },
    clickSaveMax(req) {
      if (this.validateGetMaxForm()) return;
      this.saveMaxData(req);
    },
    clickSaveMaxCustom() {
      // let getMaxCustom = this.$refs.getMaxCustom
      // if (getMaxCustom.validate() && !this.validateGetMaxForm()) {
      if (this.validateGetMaxForm()) return;
      // console.log("clickSaveMaxCustom", getMaxCustom.getData())
      let req = this.getReqForMaxSave(this.form);
      let get_max_item = [];
      this.form.max_item.forEach((index) => {
        let detail = this.maxItemDetails[index];
        get_max_item.push({
          calculationbasis1: detail.calculationbasis1,
          calculationbasis1_value: detail.calculationbasis1_value,
          operator: detail.operator,
          calculationbasis2: detail.calculationbasis2,
          calculationbasis2_value: detail.calculationbasis2_value,
        })
      });
      req.getmax.IS_CUSTOM = this.showMaxCustom;
      // req.getmax.GET_MAX_ITEM = getMaxCustom.getData();
      req.getmax.GET_MAX_ITEM = get_max_item;
      req.getmax.COVERAGECATEGORYID = this.form.categoryId;
      req.getmax.NAME = this.pageControl.coverageCategories.find(c => c.value === this.form.categoryId).text;
      this.saveMaxData(req);
    },
    async clickEditMax(e, data) {
      this.form.isEditMode = true;
      this.pageControl.settingType = 2;
      await this.setMaxFormData(data);
      //在向後端取資料時，axios會改變按鈕狀態，因此已非同步的方式完成編輯資料取值後再重新disabled
      // eslint-disable-next-line no-undef
      $(e.target)[0].disabled = true;
    },
    clickCancelMax() {
      this.resetGetMaxForm();
    },
    clickDeleteMax(data) {
      if (!confirm("確認要刪除此筆資料!?")) {
        return;
      }
      let getmaxid = null;
      if (this.showMaxCustom) {
        getmaxid = [];
        getmaxid.push(data.getmaxid);
      } else {
        getmaxid = data.getmaxid
      }
      const req = {
        PRODUCTID: this.form.productId,
        company:  this.productData.company.COMPSNM,
        insuranceName:  this.productData.insuranceName,
        insuranceCode:  this.productData.insuranceCode,
        userId: this.$store.state.userInfo.mainUserId ? this.$store.state.userInfo.mainUserId : this.$store.state.userInfo.id,
        userName: this.$store.state.userInfo.mainUserId ? "" : this.$store.state.userInfo.name,
        detail: data.detail,
        FORM_KIND: data.formkind,
        GET_MAX_ID: getmaxid,
        IS_CUSTOM: this.showMaxCustom,
      };
      this.deleteGetMax(req);
    },
    clickAllDeleteMax() {
      if (!this.hasGetMax) {
        this.$toast.info({ title: "無資料可刪除" });
        return;
      }
      if (
        !confirm("確認要刪除所有取大項目公式(只會刪除取大類，包含FORM資料)!?")
      ) {
        return;
      }
      const req = {
        PRODUCTID: this.form.productId,
        company:  this.productData.company.COMPSNM,
        insuranceName:  this.productData.insuranceName,
        insuranceCode:  this.productData.insuranceCode,
        userId: this.$store.state.userInfo.mainUserId ? this.$store.state.userInfo.mainUserId : this.$store.state.userInfo.id,
        userName: this.$store.state.userInfo.mainUserId ? "" : this.$store.state.userInfo.name,
        detailList: [],
        GET_MAX_ID: [],
        IS_CUSTOM: this.showMaxCustom,
      };
      this.filterFormularData
        .filter((item) => !item.conditionid)
        .forEach((item) => {
          req.FORM_KIND = item.formkind;
          req.GET_MAX_ID.push(item.getmaxid);
          req.detailList.push(item.detail);
        });
      this.deleteAllMax(req);
    },
    switchSettingType() {
      if (this.pageControl.settingType === 1) {
        // 保障公式設定 切到 取大設定
        this.pageControl.settingType = 2;
        this.pageControl.showRadioButtons = false;
      } else {
        // 取大設定 切到 保障公式設定
        this.pageControl.settingType = 1;
        this.pageControl.showRadioButtons = this.customPageControl.showRadioButtons;
      }
    },
    //組合儲存資料
    getReqForSave(data) {
      const req = {
        company:  this.productData.company.COMPSNM,
        insuranceName:  this.productData.insuranceName,
        insuranceCode:  this.productData.insuranceCode,
        userId: this.$store.state.userInfo.mainUserId ? this.$store.state.userInfo.mainUserId : this.$store.state.userInfo.id,
        userName: this.$store.state.userInfo.mainUserId ? "" : this.$store.state.userInfo.name,
        condition: {
          COVERAGECONDITIONID: data.conditionId,
          PRODUCTID: data.productId,
          COVERAGECATEGORYID: data.categoryId,
          NAME: this.pageControl.coverageCategories.filter(((item) => item.value == data.categoryId))[0].text,
          DUTY: data.duty,
          YEAR_TYPE: data.year_type,
          PRD: data.prd,
        },
      };
      if (this.pageControl.showScheme && !this.pageControl.showRadioButtons) {
        req.condition.SCHE_NM = data.sche_nm;
        req.condition.SCHE_AMT = data.sche_amt;
      }
      if (data.guaranteepayage) {
        req.condition.GUARANTEEPAYAGE = data.guaranteepayage;
      } else {
        req.condition.GUARANTEEPAYAGE = null;
      }
      if (data.age_limt) {
        req.condition.AGE_LIMT = data.age_limt;
      } else {
        req.condition.AGE_LIMT = null;
      }

      this.pageControl.pageBlock.forEach((block) => {
        switch (block) {
          case "period": {
            if (data.periodType == 7) {
              req.period = {
                COVERAGEPERIODTYPE: data.periodType,
                BEGINPOINT: "1",
                BEGINUNIT: "1",
                BEGINCONDITION: data.beginCondition,
                ENDCONDITION: "2",
              };
            } else if (data.periodType == 1) {
              req.period = {
                COVERAGEPERIODTYPE: data.periodType,
                BEGINPOINT: data.begin,
                BEGINUNIT: data.beginUnit,
                ENDPOINT: data.end,
                ENDUNIT: data.endUnit,
              };
            }
            break;
          }
          case "periodSingle": {
            if (data.periodType_s == 7) {
              req.period = {
                COVERAGEPERIODTYPE: data.periodType_s,
                BEGINPOINT: "1",
                BEGINUNIT: "1",
                BEGINCONDITION: data.beginCondition,
                ENDCONDITION: "2",
              };
            } else if (data.periodType_s == 1) {
              req.period = {
                COVERAGEPERIODTYPE: data.periodType_s,
                BEGINPOINT: data.begin,
                BEGINUNIT: data.beginUnit,
                ENDPOINT: data.end,
                ENDUNIT: data.endUnit,
              };
            }
            break;
          }
          case "periodMulti": {
            if (data.periodType == 7) {
              req.period = {
                COVERAGEPERIODTYPE: data.periodType,
                BEGINPOINT: "1",
                BEGINUNIT: "1",
                BEGINCONDITION: data.beginCondition1,
                ENDCONDITION: "2",
              };
            } else if (data.periodType == 8) {
              req.period = {
                COVERAGEPERIODTYPE: data.periodType,
                BEGINCONDITION: data.beginCondition2,
                ENDPOINT: this.productData.endYear,
                ENDUNIT: "2",
                ISAFTER: this.pageControl.showAfter ? "1" : "0",
              };
            } else if (data.periodType == 2) {
              req.period = {
                COVERAGEPERIODTYPE: data.periodType,
                ENDPOINT: data.end3,
                ENDUNIT: data.endUnit3,
                BEGINCONDITION: data.beginCondition3,
              };
            } else if (data.periodType == 5) {
              req.period = {
                COVERAGEPERIODTYPE: data.periodType,
                BEGINPOINT: data.begin4,
                BEGINUNIT: data.beginUnit4,
                BEGINCONDITION: data.beginCondition4,
                ENDPOINT: data.end4,
                ENDUNIT: data.endUnit4,
              };
            } else if (data.periodType == 1) {
              req.period = {
                COVERAGEPERIODTYPE: data.periodType,
                BEGINPOINT: data.begin5,
                BEGINUNIT: data.beginUnit5,
                ENDPOINT: data.end5,
                ENDUNIT: data.endUnit5,
              };
            } else if (data.periodType == 3) {
              req.period = {
                COVERAGEPERIODTYPE: data.periodType,
                BEGINPOINT: data.begin6,
                BEGINUNIT: data.beginUnit6,
                ENDCONDITION: data.endCondition6,
              };
            } else if (data.periodType == 4) {
              req.period = {
                COVERAGEPERIODTYPE: data.periodType,
                BEGINPOINT: data.begin7,
                BEGINUNIT: data.beginUnit7,
              };
            }
            if (this.pageControl.showNextDay) {
              req.period.HASNEXTDAY = data.isNextDay ? 2 : 0;
            }
            break;
          }
          case "periodGoodwish": {
            req.period = {
              COVERAGEPERIODTYPE: 4,
              BEGINPOINT: data.begin,
              BEGINUNIT: data.beginUnit,
              BEGINCONDITION: data.beginCondition,
              ENDPOINT: data.end,
              ENDUNIT: data.endUnit,
            };
            break;
          }
          case "formula": {
            req.formula = [];
            const obj = {
              FORMULAID: data.formulaId,
              FORMULATYPE: data.formulaType,
              CALC_BASIS: data.calc_basis,
              PERIOD_LOWER: data.period_lower,
              UNIT_LOWER: data.unit_lower,
              UNIT_UPPER: data.unit_upper,
            };
            if (this.pageControl.showUpper) {
              obj.PERIOD_UPPER = data.period_upper;
            } else {
              obj.UNIT_UPPER = 0;
            }
            if (this.pageControl.showBenefitTypes) {
              obj.BNF_TYPE = data.benefitTypeId;
              obj.FORMULATYPE = 3;
              if (this.form.benefit_max) {
                obj.MAX_BNF_LIMT = data.benefit_max * 10000;
              }
            }
            req.formula.push(obj);
            break;
          }
          case "formulaSingle": {
            req.formula = [];
            const obj = {};
            obj.POSITION = data.position_s;
            if (data.position_s == 1) {
              obj.FORMULAID = data.formulaId_s1;
              obj.FORMULATYPE = 1;
              obj.CALC_BASIS = data.calc_basis_s1;
              obj.PERIOD_LOWER = data.period_lower_s1;
              obj.UNIT_LOWER = data.unit_lower_s1;
              obj.PERIOD_UPPER = data.period_upper_s1;
              obj.UNIT_UPPER = data.unit_upper_s1;
            } else if (data.position_s == 0) {
              obj.FORMULAID = data.formulaId_s2;
              obj.FORMULATYPE = 3;
              obj.CALC_BASIS = data.calc_basis_s2;
              obj.PERIOD_LOWER = data.period_lower_s2;
              obj.UNIT_LOWER = data.unit_lower_s2;
              obj.UNIT_UPPER = 0;
              if (this.form.benefit_max) {
                obj.MAX_BNF_LIMT = data.benefit_max * 10000;
              }
            } else if (data.position_s == 3) {
              obj.FORMULAID = data.formulaId_s3;
              obj.FORMULATYPE = 1;
              obj.CALC_BASIS = 0;
              obj.PERIOD_LOWER = data.period_lower_s3;
              obj.UNIT_LOWER = data.unit_lower_s3;
              obj.UNIT_UPPER = 0;
              req.condition.SCHE_NM = data.sche_nm_s3;
              req.condition.SCHE_AMT = data.sche_amt_s3;
            } else if (data.position_s == 4) {
              obj.FORMULAID = data.formulaId_s4;
              obj.FORMULATYPE = 1;
              obj.CALC_BASIS = data.calc_basis_s4;
              obj.PERIOD_LOWER = data.period_lower_s4;
              obj.UNIT_LOWER = data.unit_lower_s4;
              obj.PERIOD_UPPER = data.period_upper_s4;
              obj.UNIT_UPPER = data.unit_upper_s4;
              req.condition.SCHE_NM = data.sche_nm_s4;
              req.condition.SCHE_AMT = data.sche_amt_s4;
            }
            req.formula.push(obj);
            break;
          }
          case "formulaMulti": {
            req.formula = [];
            data.position.forEach((item) => {
              const obj = {};
              obj.POSITION = item % 6;
              if (item == 0) {
                obj.FORMULAID = data.formulaId1;
                obj.FORMULATYPE = 8;
                obj.CALC_BASIS = data.calc_basis1;
                obj.VALUE = data.period_lower1;
                obj.UNIT_LOWER = data.unit_lower1;
                obj.UNIT_UPPER = 0;
                obj.YEARPROGRESSION = 1;
                if (this.form.benefit_max) {
                  obj.MAX_BNF_LIMT = data.benefit_max * 10000;
                }
                obj.PERIOD_LOWER = data.period_lower1;
              } else if (item == 1) {
                obj.FORMULAID = data.formulaId2;
                obj.FORMULATYPE = 4;
                obj.YEARPROGRESSION = data.yearprogression2;
                obj.CALC_BASIS = data.calc_basis2;
                obj.INTERESTTYPE = data.interestType2;
                obj.VALUE = data.period_lower2;
                obj.UNIT_LOWER = data.unit_lower2;
                obj.UNIT_UPPER = 0;
                obj.FORMULATREND = data.formulaTrend2;
              } else if (item == 2) {
                obj.FORMULAID = data.formulaId3;
                obj.FORMULATYPE = 4;
                obj.YEARPROGRESSION = data.yearprogression3;
                obj.CALC_BASIS = data.calc_basis3;
                obj.INTERESTTYPE = data.interestType3;
                obj.VALUE = data.period_lower3;
                obj.UNIT_LOWER = data.unit_lower3;
                obj.UNIT_UPPER = 0;
                obj.FORMULATREND = data.formulaTrend3;
              } else if (item == 3) {
                obj.FORMULAID = data.formulaId4;
                obj.FORMULATYPE = 4;
                obj.YEARPROGRESSION = data.yearprogression4;
                obj.CALC_BASIS = data.calc_basis4;
                obj.INTERESTTYPE = data.interestType4;
                obj.VALUE = data.period_lower4;
                obj.UNIT_LOWER = data.unit_lower4;
                obj.UNIT_UPPER = 0;
                obj.FORMULATREND = data.formulaTrend4;
              } else if (item == 4) {
                obj.FORMULAID = data.formulaId5;
                obj.FORMULATYPE = 4;
                obj.YEARPROGRESSION = data.yearprogression5;
                obj.CALC_BASIS = data.calc_basis5;
                obj.INTERESTTYPE = data.interestType5;
                obj.VALUE = data.period_lower5;
                obj.UNIT_LOWER = data.unit_lower5;
                obj.UNIT_UPPER = 0;
                obj.FORMULATREND = data.formulaTrend5;
              } else if (item == 5) {
                obj.FORMULAID = data.formulaId6;
                obj.FORMULATYPE = 4;
                obj.YEARPROGRESSION = data.yearprogression6;
                obj.CALC_BASIS = data.calc_basis6;
                obj.INTERESTTYPE = data.interestType6;
                obj.VALUE = data.period_lower6;
                obj.UNIT_LOWER = data.unit_lower6;
                obj.UNIT_UPPER = 0;
                obj.FORMULATREND = data.formulaTrend6;
                obj.MULTIPLIER = data.multiplier;
              } else if (item == 6) {
                obj.FORMULAID = data.formulaId7;
                obj.FORMULATYPE = 5;
                obj.CALC_BASIS = 0;
                obj.UNIT_LOWER = 0;
                obj.UNIT_UPPER = 0;
                obj.APPEND = data.append;
              }
              // 多行型公式：若顯示給付方式，補上給付方式(BNF_TYPE)傳給後端
              if (this.pageControl.showBenefitTypes) {
                obj.BNF_TYPE = data.benefitTypeId;
              }
              req.formula.push(obj);
            });
            break;
          }
          case "formulaGoodwish": {
            req.formula = [];
            const obj = {
              FORMULAID: data.formulaId,
              FORMULATYPE: data.formulaType,
              CALC_BASIS: data.calc_basis,
              PERIOD_LOWER: data.period_lower,
              UNIT_LOWER: data.unit_lower,
              UNIT_UPPER: 0,
            };
            req.formula.push(obj);
            break;
          }
        }
      });

      //豁免保障設定頁沒有pageBlock，因此formula和period填入預設值
      if(this.pageControl.pageName == "豁免保障") {
        req.formula = [];
        const obj = {
          FORMULAID: data.formulaId,
          FORMULATYPE: 2, //2:豁免型
          CALC_BASIS: 0,
          UNIT_LOWER: 0,
          UNIT_UPPER: 0,
        };
        req.formula.push(obj);
        req.period = { COVERAGEPERIODTYPE: 6 }; //6:Null
      }

      return req;
    },
    //參數檢查
    validateForm() {
      let isError = false;
      this.validate = this.$options.data().validate;

      if (this.needValidate.duty && !this.form.duty) {
        isError = true;
        this.validate.isDutyErr = true;
        this.$toast.info({ title: "[保障對象]選單必須選擇" });
      }
      if (this.needValidate.prd && !this.form.prd && this.form.prd != 0) {
        isError = true;
        this.validate.isPrdErr = true;
        this.$toast.info({ title: "[保障年期]選單必須選擇" });
      }
      if (
        this.needValidate.parentCategoryName &&
        !this.pageControl.parentCategoryName
      ) {
        isError = true;
        this.validate.isPrimaryCategoryErr = true;
        this.$toast.info({ title: "[保障項目類別]選單必須選擇" });
      }
      if (this.needValidate.categoryId && !this.form.categoryId) {
        isError = true;
        this.validate.isCategoryIdErr = true;
        this.$toast.info({ title: "[保障項目]選單必須選擇" });
      }
      if (this.showPeriod) {
        if (this.needValidate.periodType && !this.form.periodType) {
          isError = true;
          this.validate.isPeriodTypeErr = true;
          this.$toast.info({ title: "[保障期間]選單必須選擇" });
        }
        if (this.form.periodType == 1) {
          if (this.needValidate.begin && !this.form.begin) {
            isError = true;
            this.validate.isBeginErr = true;
            this.$toast.info({ title: "[保障期間]起始值必須填寫" });
          }
          if (this.needValidate.beginUnit && !this.form.beginUnit) {
            isError = true;
            this.validate.isBeginUnitErr = true;
            this.$toast.info({ title: "[保障期間]起始值單位必須選擇" });
          }
          if (this.needValidate.end && !this.form.end) {
            isError = true;
            this.validate.isEndErr = true;
            this.$toast.info({ title: "[保障期間]結束值必須填寫" });
          }
          if (this.needValidate.endUnit && !this.form.endUnit) {
            isError = true;
            this.validate.isEndUnitErr = true;
            this.$toast.info({ title: "[保障期間]結束值單位必須選擇" });
          }
          if (parseInt(this.form.begin) > parseInt(this.form.end)) {
            isError = true;
            this.validate.isBeginErr = true;
            this.$toast.info({ title: "[保障期間]起始值不可大於終止值" });
          }
        }
      }
      if (this.showPeriodSingle) {
        if (this.needValidate.periodType_s && !this.form.periodType_s) {
          isError = true;
          this.validate.isPeriodType_sErr = true;
          this.$toast.info({ title: "[保障期間]選單必須選擇" });
        }
        if (this.form.periodType_s == 1) {
          if (this.needValidate.begin && !this.form.begin) {
            isError = true;
            this.validate.isBeginErr = true;
            this.$toast.info({ title: "[保障期間]起始值必須填寫" });
          }
          if (this.needValidate.beginUnit && !this.form.beginUnit) {
            isError = true;
            this.validate.isBeginUnitErr = true;
            this.$toast.info({ title: "[保障期間]起始值單位必須選擇" });
          }
          if (this.needValidate.end && !this.form.end) {
            isError = true;
            this.validate.isEndErr = true;
            this.$toast.info({ title: "[保障期間]結束值必須填寫" });
          }
          if (this.needValidate.endUnit && !this.form.endUnit) {
            isError = true;
            this.validate.isEndUnitErr = true;
            this.$toast.info({ title: "[保障期間]結束值單位必須選擇" });
          }
          if (parseInt(this.form.begin) > parseInt(this.form.end)) {
            isError = true;
            this.validate.isBeginErr = true;
            this.$toast.info({ title: "[保障期間]起始值不可大於終止值" });
          }
        }
      }
      if (this.showPeriodMulti) {
        if (this.needValidate.periodType && !this.form.periodType) {
          isError = true;
          this.validate.isPeriodTypeErr = true;
          this.$toast.info({ title: "[保障期間]選單必須選擇" });
        }
        if (this.form.periodType == 7) {
          if (this.needValidate.beginCondition1 && !this.form.beginCondition1) {
            isError = true;
            this.validate.isBegin_condErr1 = true;
            this.$toast.info({ title: "[保障期間]保障期間型態必須選擇" });
          }
        } else if (this.form.periodType == 8) {
          if (this.needValidate.beginCondition2 && !this.form.beginCondition2) {
            isError = true;
            this.validate.isBegin_condErr2 = true;
            this.$toast.info({ title: "[保障期間]保障期間型態必須選擇" });
          }
        } else if (this.form.periodType == 2) {
          if (this.needValidate.beginCondition3 && !this.form.beginCondition3) {
            isError = true;
            this.validate.isBegin_condErr3 = true;
            this.$toast.info({ title: "[保障期間]保障期間型態必須選擇" });
          }
          if (this.needValidate.end3 && !this.form.end3) {
            isError = true;
            this.validate.isEndErr3 = true;
            this.$toast.info({ title: "[保障期間]結束值必須填寫" });
          }
          if (this.needValidate.endUnit3 && !this.form.endUnit3) {
            isError = true;
            this.validate.isEndUnitErr3 = true;
            this.$toast.info({ title: "[保障期間]結束值單位必須選擇" });
          }
        } else if (this.form.periodType == 5) {
          if (this.needValidate.beginCondition4 && !this.form.beginCondition4) {
            isError = true;
            this.validate.isBegin_condErr4 = true;
            this.$toast.info({ title: "[保障期間]保障期間型態必須選擇" });
          }
          if (this.needValidate.begin4 && !this.form.begin4) {
            isError = true;
            this.validate.isBeginErr4 = true;
            this.$toast.info({ title: "[保障期間]起始值必須填寫" });
          }
          if (this.needValidate.beginUnit4 && !this.form.beginUnit4) {
            isError = true;
            this.validate.isBeginUnitErr4 = true;
            this.$toast.info({ title: "[保障期間]起始值單位必須選擇" });
          }
          if (this.needValidate.end4 && !this.form.end4) {
            isError = true;
            this.validate.isEndErr4 = true;
            this.$toast.info({ title: "[保障期間]結束值必須填寫" });
          }
          if (this.needValidate.endUnit4 && !this.form.endUnit4) {
            isError = true;
            this.validate.isEndUnitErr4 = true;
            this.$toast.info({ title: "[保障期間]結束值單位必須選擇" });
          }
          if (parseInt(this.form.begin4) > parseInt(this.form.end4)) {
            isError = true;
            this.validate.isBeginErr4 = true;
            this.$toast.info({ title: "[保障期間]起始值不可大於終止值" });
          }
        } else if (this.form.periodType == 1) {
          if (this.needValidate.begin5) {
            const isLivingOrMaturity = this.pageControl.pageName === "生存保險金" || this.pageControl.pageName === "滿期保險金";
            if ((!this.form.begin5 && !isLivingOrMaturity) || (this.form.begin5 < 0 && isLivingOrMaturity)) {
              isError = true;
              this.validate.isBeginErr5 = true;
              this.$toast.info({ title: "[保障期間]起始值必須填寫" });
            }
          }
          if (this.needValidate.beginUnit5 && !this.form.beginUnit5) {
            isError = true;
            this.validate.isBeginUnitErr5 = true;
            this.$toast.info({ title: "[保障期間]起始值單位必須選擇" });
          }
          if (this.needValidate.end5 && !this.form.end5) {
            isError = true;
            this.validate.isEndErr5 = true;
            this.$toast.info({ title: "[保障期間]結束值必須填寫" });
          }
          if (this.needValidate.endUnit5 && !this.form.endUnit5) {
            isError = true;
            this.validate.isEndUnitErr5 = true;
            this.$toast.info({ title: "[保障期間]結束值單位必須選擇" });
          }
          if (parseInt(this.form.begin5) > parseInt(this.form.end5)) {
            isError = true;
            this.validate.isBeginErr5 = true;
            this.$toast.info({ title: "[保障期間]起始值不可大於終止值" });
          }
        } else if (this.form.periodType == 3) {
          if (this.needValidate.endCondition6 && !this.form.endCondition6) {
            isError = true;
            this.validate.isEnd_CondErr6 = true;
            this.$toast.info({ title: "[保障期間]保障期間型態必須選擇" });
          }
          if (this.needValidate.begin6 && !this.form.begin6) {
            isError = true;
            this.validate.isBeginErr6 = true;
            this.$toast.info({ title: "[保障期間]起始值必須填寫" });
          }
          if (this.needValidate.beginUnit6 && !this.form.beginUnit6) {
            isError = true;
            this.validate.isBeginUnitErr6 = true;
            this.$toast.info({ title: "[保障期間]起始值單位必須選擇" });
          }
        } else if (this.form.periodType == 4) {
          if (this.needValidate.begin7 && !this.form.begin7) {
            isError = true;
            this.validate.isBeginErr7 = true;
            this.$toast.info({ title: "[保障期間]起始值必須填寫" });
          }
          if (this.needValidate.beginUnit7 && !this.form.beginUnit7) {
            isError = true;
            this.validate.isBeginUnitErr7 = true;
            this.$toast.info({ title: "[保障期間]起始值單位必須選擇" });
          }
        }
      }
      if (this.showPeriodGoodwish) {
        if (this.needValidate.periodType && !this.form.periodType) {
          isError = true;
          this.validate.isPeriodTypeErr = true;
          this.$toast.info({ title: "[保障期間]選單必須選擇" });
        }
        if (this.form.periodType == 4) {
          if (this.needValidate.begin && !this.form.begin) {
            isError = true;
            this.validate.isBeginErr = true;
            this.$toast.info({ title: "[保障期間]起始值必須填寫" });
          }
          if (this.needValidate.beginUnit && !this.form.beginUnit) {
            isError = true;
            this.validate.isBeginUnitErr = true;
            this.$toast.info({ title: "[保障期間]起始值單位必須選擇" });
          }
        }
      }
      if (this.showFormula) {
        if (this.needValidate.calc_basis && !this.form.calc_basis) {
          isError = true;
          this.validate.isCalc_basisErr = true;
          this.$toast.info({ title: "[保障公式]選單必須選擇" });
        }
        if (this.needValidate.period_lower && !this.form.period_lower) {
          isError = true;
          this.validate.isPeriod_lowerErr = true;
          this.$toast.info({ title: "[保障公式]值必須填寫" });
        }
        if (this.needValidate.unit_lower && !this.form.unit_lower) {
          isError = true;
          this.validate.isUnit_lowerErr = true;
          this.$toast.info({ title: "[保障公式]值單位必須填寫" });
        }
        if (this.pageControl.showUpper) {
          if (this.needValidate.period_upper && !this.form.period_upper) {
            isError = true;
            this.validate.isPeriod_upperErr = true;
            this.$toast.info({ title: "[保障公式]值必須填寫" });
          }
        }
      }
      if (this.showFormulaSingle) {
        if (this.needValidate.position_s && (this.form.position_s != 0 && !this.form.position_s)) {
          isError = true;
          this.validate.isPosition_sErr = true;
          this.$toast.info({ title: "[保障公式]選單必須選擇" });
        } else {
          if (this.form.position_s == 1) {
            if (this.needValidate.calc_basis_s1 && !this.form.calc_basis_s1) {
              isError = true;
              this.validate.isCalc_basisErr_s1 = true;
              this.$toast.info({ title: "[保障公式]選單必須選擇" });
            }
            if (
              this.needValidate.period_lower_s1 &&
              !this.form.period_lower_s1
            ) {
              isError = true;
              this.validate.isPeriod_lowerErr_s1 = true;
              this.$toast.info({ title: "[保障公式]值必須填寫" });
            }
          } else if (this.form.position_s == 0) {
            if (this.needValidate.calc_basis_s2 && !this.form.calc_basis_s2) {
              isError = true;
              this.validate.isCalc_basisErr_s2 = true;
              this.$toast.info({ title: "[保障公式]選單必須選擇" });
            }
            if (
              this.needValidate.period_lower_s2 &&
              !this.form.period_lower_s2
            ) {
              isError = true;
              this.validate.isPeriod_lowerErr_s2 = true;
              this.$toast.info({ title: "[保障公式]值必須填寫" });
            }
          } else if (this.form.position_s == 3) {
            if (
              this.needValidate.sche_amt_s3 &&
              this.pageControl.schemeItems.length == 0
            ) {
              isError = true;
              this.validate.isSche_amtErr_s3 = true;
              this.$toast.info({ title: "[保障公式]計劃必須選擇" });
            }
            if (
              this.needValidate.period_lower_s3 &&
              !this.form.period_lower_s3
            ) {
              isError = true;
              this.validate.isPeriod_lowerErr_s3 = true;
              this.$toast.info({ title: "[保障公式]值必須填寫" });
            }
          } else if (this.form.position_s == 4) {
            if (
              this.needValidate.sche_amt_s4 &&
              this.pageControl.schemeItems.length == 0
            ) {
              isError = true;
              this.validate.isSche_amtErr_s4 = true;
              this.$toast.info({ title: "[保障公式]計劃必須選擇" });
            }
            if (this.needValidate.calc_basis_s4 && !this.form.calc_basis_s4) {
              isError = true;
              this.validate.isCalc_basisErr_s4 = true;
              this.$toast.info({ title: "[保障公式]選單必須選擇" });
            }
            if (
              this.needValidate.period_lower_s4 &&
              !this.form.period_lower_s4
            ) {
              isError = true;
              this.validate.isPeriod_lowerErr_s4 = true;
              this.$toast.info({ title: "[保障公式]值必須填寫" });
            }
          }
        }
      }
      if (this.showFormulaMulti) {
        if (this.needValidate.position && this.form.position.length === 0) {
          isError = true;
          this.validate.isPositionErr = true;
          this.$toast.info({ title: "[保障公式]選單必須選擇" });
        } else {
          this.form.position.forEach((item) => {
            if (item == 0) {
              if (this.needValidate.period_lower1 && !this.form.period_lower1) {
                isError = true;
                this.validate.isPeriod_lowerErr1 = true;
                this.$toast.info({ title: "[保障公式]值必須填寫" });
              }
            } else if (item == 1) {
              if (
                this.needValidate.yearprogression2 &&
                !this.form.yearprogression2
              ) {
                isError = true;
                this.validate.isYear_progErr2 = true;
                this.$toast.info({ title: "[保障公式]累進年數必須填寫" });
              }
              if (this.needValidate.period_lower2 && !this.form.period_lower2) {
                isError = true;
                this.validate.isPeriod_lowerErr2 = true;
                this.$toast.info({ title: "[保障公式]值必須填寫" });
              }
            } else if (item == 2) {
              if (
                this.needValidate.yearprogression3 &&
                !this.form.yearprogression3
              ) {
                isError = true;
                this.validate.isYear_progErr3 = true;
                this.$toast.info({ title: "[保障公式]累進年數必須填寫" });
              }
              if (this.needValidate.period_lower3 && !this.form.period_lower3) {
                isError = true;
                this.validate.isPeriod_lowerErr3 = true;
                this.$toast.info({ title: "[保障公式]值必須填寫" });
              }
            } else if (item == 3) {
              if (
                this.needValidate.yearprogression4 &&
                !this.form.yearprogression4
              ) {
                isError = true;
                this.validate.isYear_progErr4 = true;
                this.$toast.info({ title: "[保障公式]累進年數必須填寫" });
              }
              if (this.needValidate.period_lower4 && !this.form.period_lower4) {
                isError = true;
                this.validate.isPeriod_lowerErr4 = true;
                this.$toast.info({ title: "[保障公式]值必須填寫" });
              }
            } else if (item == 4) {
              if (
                this.needValidate.yearprogression5 &&
                !this.form.yearprogression5
              ) {
                isError = true;
                this.validate.isYear_progErr5 = true;
                this.$toast.info({ title: "[保障公式]累進年數必須填寫" });
              }
              if (this.needValidate.period_lower5 && !this.form.period_lower5) {
                isError = true;
                this.validate.isPeriod_lowerErr5 = true;
                this.$toast.info({ title: "[保障公式]值必須填寫" });
              }
            } else if (item == 5) {
              if (
                this.needValidate.yearprogression6 &&
                !this.form.yearprogression6
              ) {
                isError = true;
                this.validate.isYear_progErr6 = true;
                this.$toast.info({ title: "[保障公式]累進年數必須填寫" });
              }
              if (this.needValidate.period_lower6 && !this.form.period_lower6) {
                isError = true;
                this.validate.isPeriod_lowerErr6 = true;
                this.$toast.info({ title: "[保障公式]值必須填寫" });
              }
            }
          });
        }
      }
      if (this.showFormulaGoodwish) {
        if (this.needValidate.calc_basis && !this.form.calc_basis) {
          isError = true;
          this.validate.isCalc_basisErr = true;
          this.$toast.info({ title: "[保障公式]選單必須選擇" });
        }
        if (this.needValidate.period_lower && !this.form.period_lower) {
          isError = true;
          this.validate.isPeriod_lowerErr = true;
          this.$toast.info({ title: "[保障公式]值必須填寫" });
        }
        if (this.needValidate.unit_lower && !this.form.unit_lower) {
          isError = true;
          this.validate.isUnit_lowerErr = true;
          this.$toast.info({ title: "[保障公式]值單位必須填寫" });
        }
      }

      return isError;
    },
    //組合取大設定儲存資料
    getReqForMaxSave(data) {
      const req = {
        company:  this.productData.company.COMPSNM,
        insuranceName:  this.productData.insuranceName,
        insuranceCode:  this.productData.insuranceCode,
        userId: this.$store.state.userInfo.mainUserId ? this.$store.state.userInfo.mainUserId : this.$store.state.userInfo.id,
        userName: this.$store.state.userInfo.mainUserId ? "" : this.$store.state.userInfo.name,
        getmax: {
          PRODUCTID: data.productId,
          GET_MAX_PERIOD: data.max_period,
          FORM_KIND: data.form_kind,
          YEAR_TYPE: data.year_type,
          PRD: data.prd,
        },
      };

      if (data.getMaxId) {
        req.getmax.GET_MAX_ID = data.getMaxId;
      }

      if (data.max_period == 3) {
        req.getmax.YEAR_AFTER_START = data.year_after_start;
      } else if (data.max_period == 4) {
        req.getmax.START = data.max_start;
        req.getmax.START_UNIT = data.max_start_unit;
        req.getmax.END = data.max_end;
        req.getmax.END_UNIT = data.max_end_unit;
      }

      if (data.max_item.length > 0) {
        req.getmax.GET_MAX_ITEM = data.max_item.toString();
        if (data.max_item.includes("3")) {
          req.getmax.BASIC_INSURANCE_MULTIPLE = data.basic_insurance_multiple;
        }
        if (data.max_item.includes("4")) {
          req.getmax.MULTIPLE_TOTAL_PREMIUM = data.multiple_total_premium;
        }
        if (data.max_item.includes("7")) {
          req.getmax.TOTAL_PREMIUM_SUBTRACT_LIFEANNUITY =
            data.total_premium_subtract_lifeannuity;
        }
        if (data.max_item.includes("11")) {
          req.getmax.INSURANCE_AMOUNT_TIMES = data.insurance_amount_times;
          req.getmax.TOTAL_PREMIUM_TIMES = data.total_premium_times;
        }
        if (data.max_item.includes("9")) {
          req.getmax.ADD_MULTIPLE_TOTAL_PREMIUM =
            data.add_multiple_total_premium;
        }
      } else {
        req.getmax.GET_MAX_ITEM = "";
      }

      return req;
    },
    //取大設定參數檢查
    validateGetMaxForm() {
      let isError = false;
      this.validate = this.$options.data().validate;
      this.resetGetMaxCustomValidate();
      
      if (this.needValidate.max_period && !this.form.max_period) {
        isError = true;
        this.validate.isMaxPeriodErr = true;
        this.$toast.info({ title: "[取大設定]取大期間必須選擇" });
      }
      if (this.form.max_period == 3) {
        if (this.needValidate.year_after_start && !this.form.year_after_start) {
          isError = true;
          this.validate.isYearAfterStartErr = true;
          this.$toast.info({ title: "[取大設定]年後開始之資料值必須填寫" });
        }
      } else if (this.form.max_period == 4) {
        if (this.needValidate.max_start && !this.form.max_start) {
          isError = true;
          this.validate.isMaxStartErr = true;
          this.$toast.info({ title: "[取大設定]起始值必須填寫" });
        }
        if (this.needValidate.max_end && !this.form.max_end) {
          isError = true;
          this.validate.isMaxEndErr = true;
          this.$toast.info({ title: "[取大設定]結束值必須填寫" });
        }
      }

      if (this.showMaxCustom) {
        if (this.form.max_item.length > 0) {
          this.form.max_item.forEach((index) => {
            let detail = this.maxItemDetails[index];
            console.log("detail.calculationbasis1", detail.calculationbasis1)
            if (detail.calculationbasis1 == "0") {
              detail.is_calculationbasis1_error = true;
              isError = true;
            }
            if (detail.calculationbasis1_value.length == 0) {
              detail.is_calculationbasis1_value_error = true;
              isError = true;
            }
            if (detail.operator != "0") {
              if (detail.calculationbasis2 == "0") {
                detail.is_calculationbasis2_error = true;
                isError = true;
              }
              if (detail.calculationbasis2_value.length == 0) {
                detail.is_calculationbasis2_value_error = true;
                isError = true;
              }
            } else {
              if (detail.calculationbasis2 != "0") {
                detail.is_operator_error = true;
                isError = true;
                if (detail.calculationbasis2_value.length == 0) {
                  detail.is_calculationbasis2_value_error = true;
                  isError = true;
                }
              }
            }

            detail.is_calculationbasis1_error 
              && this.$toast.info({ title: "[取大項目]請選擇第一種計算基礎" });
            detail.is_calculationbasis1_value_error 
              && this.$toast.info({ title: "[取大項目]請輸入第一種計算基礎的倍數" });
            detail.is_operator_error 
              && this.$toast.info({ title: "[取大項目]請選擇運算符號" });
            detail.is_calculationbasis2_error 
              && this.$toast.info({ title: "[取大項目]請選擇第二種計算基礎" });
            detail.is_calculationbasis2_value_error 
              && this.$toast.info({ title: "[取大項目]請輸入第二種計算基礎的倍數" });
          });
        } else {
          this.$toast.info({ title: "[取大項目]需勾選至少一項取大項目" });
          isError = true;
        }
      }
      else {
        const regexDecimal = /^[-+]?[0-9]{0,4}([.]{1}[0-9]{0,4})?$/;
        if (this.form.max_item.includes("3")) {
          if (
            this.needValidate.basic_insurance_multiple &&
            (!this.form.basic_insurance_multiple ||
              !regexDecimal.test(this.form.basic_insurance_multiple))
          ) {
            isError = true;
            this.validate.isBasic_insurance_multipleErr = true;
            this.$toast.info({
              title: "[基本保額]倍數之資料值必須填寫或格式不正確",
            });
          }
        }
        if (this.form.max_item.includes("4")) {
          if (
            this.needValidate.multiple_total_premium &&
            (!this.form.multiple_total_premium ||
              !regexDecimal.test(this.form.multiple_total_premium))
          ) {
            isError = true;
            this.validate.isMultiple_total_premiumErr = true;
            this.$toast.info({
              title: "[年繳化總繳保費]倍數之資料值必須填寫或格式不正確",
            });
          }
        }
        if (this.form.max_item.includes("7")) {
          if (
            this.needValidate.total_premium_subtract_lifeannuity &&
            (!this.form.total_premium_subtract_lifeannuity ||
              !regexDecimal.test(this.form.total_premium_subtract_lifeannuity))
          ) {
            isError = true;
            this.validate.isTotal_premium_subtract_lifeannuityErr = true;
            this.$toast.info({
              title:
                "[年繳化總繳保費扣已領生存年金]倍數之資料值必須填寫或格式不正確",
            });
          }
        }
        if (this.form.max_item.includes("11")) {
          if (
            this.needValidate.insurance_amount_times &&
            (!this.form.insurance_amount_times ||
              !regexDecimal.test(this.form.insurance_amount_times))
          ) {
            isError = true;
            this.validate.isInsurance_amount_timesErr = true;
            this.$toast.info({
              title:
                "[基本保額＋年繳化總繳保費]的【基本保額】倍數之資料值必須填寫或格式不正確",
            });
          }
          if (
            this.needValidate.total_premium_times &&
            (!this.form.total_premium_times ||
              !regexDecimal.test(this.form.total_premium_times))
          ) {
            isError = true;
            this.validate.isTotal_premium_timesErr = true;
            this.$toast.info({
              title:
                "[基本保額＋年繳化總繳保費]的【年繳化總繳保費】倍數之資料值必須填寫或格式不正確",
            });
          }
        }
        if (this.form.max_item.includes("9")) {
          if (
            this.needValidate.add_multiple_total_premium &&
            (!this.form.add_multiple_total_premium ||
              !regexDecimal.test(this.form.add_multiple_total_premium))
          ) {
            isError = true;
            this.validate.isAdd_multiple_total_premiumErr = true;
            this.$toast.info({
              title:
                "[當年度保額＋年繳化總繳保費]倍數之資料值必須填寫或格式不正確",
            });
          }
        }
      }
      return isError;
    },
    resetGetMaxCustomValidate() {
      this.maxItemDetails.forEach((detail) => {
        detail.is_calculationbasis1_error = false;
        detail.is_calculationbasis1_value_error = false;
        detail.is_operator_error = false;
        detail.is_calculationbasis2_error = false;
        detail.is_calculationbasis2_value_error = false;
      });
    },
  },
  mounted() {
    this.pageInit();
  },
  created() {
    this.getMaxCustomInit();
  }
};
</script>
<style lang="scss" scoped>
/deep/ .mt-40 {
  margin-top: 40px;
}
/deep/ .fs-12 {
  font-size: 12px;
}
/deep/ .mr-0 {
  margin-right: 0px !important;
}
/deep/ .lh-40 {
  line-height: 40px;
}
/deep/ .w-20 {
  width: 20px !important;
}
/deep/ .w-100 {
  width: 100px !important;
}
/deep/ .w-130 {
  width: 130px !important;
}
/deep/ .w-250 {
  width: 250px !important;
}
/deep/ .w-325 {
  width: 325px !important;
}
/deep/ .mb-15 {
  margin-bottom: 15px;
}
/deep/ .ml-15 {
  margin-left: 15px;
}
/deep/ .ml-50 {
  margin-left: 50px !important;
}
/deep/ .show-input {
  opacity: unset;
  position: unset;
}
/deep/ .searchArea {
  border-color: #027a39;
  border-width: 3px;
  background-color: white;
}
/deep/ .d-inline-grid {
  display: inline-grid;
}
/deep/ .hide-label {
  height: 0;
}
.td-center {
  vertical-align: middle !important;
  text-align: center !important;
  padding: 10px !important;
}
.active :not(nav-link) {
  background-color: #f5dec5;
}
/deep/ .nav {
  height: 37px;
}
/deep/ .nav-item {
  border-color: #90a892;
  background-color: #f4f9f6;
  border-bottom-color: rgba(0, 0, 0, 0);
  border-style: solid;
  border-width: 2.5px;
  border-bottom-width: 3px;
  border-bottom-color: #027a39;
  border-radius: 6px 6px 0px 0px;
  width: 150px;
  height: 40px;
  text-align: center;
  position: absolute;
  font-weight: 600;
}
/deep/ .nav-first {
  margin-left: 20px;
}
/deep/ .nav-second {
  margin-left: 180px;
}
/deep/ .nav-item > a {
  color: #90a892;
}
/deep/ .nav-item.nav-active > a {
  color: #048f3a;
}
/deep/ .nav-active {
  border-color: #027a39;
  border-bottom-color: white;
  background-color: rgba(0, 0, 0, 0);
}
</style>
